import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';

const FeeDashboardLazy = React.lazy(
	() => import(/* webpackChunkName : 'FeeDashboard' */ './components')
);

export default (store) => [
	{
		path: 'fee-dashboard',
		element: <AsyncLoading component={<FeeDashboardLazy />} />,
	},
];
